import { Icon } from '../icon'
import { useStyles } from './styles'
import { IconProps } from '../icon'
import { EarnedPoints } from '../earnedPoints'

type InfoBlockProps = {
  width: string
  minHeight?: string
  icon: ViewType
  title: string
  description: string
  bgColor?: string
  iconWidth?: number
  additionalPoints?: number
  borderRadius?: `${number}px` | `${number}%`
}

type ViewType = IconProps['view']

export const InfoBlock = (props: InfoBlockProps) => {
  const {
    width,
    minHeight,
    icon,
    title,
    description,
    iconWidth,
    additionalPoints,
    bgColor,
    borderRadius = '0px',
  } = props
  const { classes } = useStyles()

  return (
    <div
      className={classes.root}
      style={{ width: width, minHeight: minHeight, background: bgColor, borderRadius: borderRadius }}
    >
      <div className={classes.iconWrapper}>
        <Icon
          view={icon}
          width={iconWidth}
        />
      </div>
      <div className={classes.textWrapper}>
        <div className={classes.headingWrapper}>
          <span className={classes.heading}>{title}</span>
          {additionalPoints && <EarnedPoints points={5000} />}
        </div>
        <span className={classes.description}>{description}</span>
      </div>
      {additionalPoints && (
        <div className={classes.arrowWrapper}>
          <Icon
            view="roundedArrow"
            width={16}
          />
        </div>
      )}
    </div>
  )
}
